<template>
    <main class="cover-container" v-show="!isRequestLoading">
        <LoginForm ref="loginform" @on-success="handleLoginSuccess"></LoginForm>
        <template v-if="!isShowLogin">
            <div class="header" :style="headerBgImage">
                <div class="wapper-title">
                    <div class="title" v-for="title in titleList" :key="title">
                        <h3>{{ title }}</h3>
                    </div>
                </div>
                <div class="subtitle" v-if="coverConfig.subTitle">
                    {{ coverConfig.subTitle }}
                </div>
            </div>
            <div class="content-wrapper">
                <div class="content">
                    <p v-for="(con, index) in contents" :key="index">{{ con }}</p>
                </div>
            </div>
            <div class="btn-wrapper">
                <div class="btn" @click="hanldeStartA">
                    {{ coverConfig.btnContext || '开始答题' }}
                </div>
            </div>
        </template>
    </main>
</template>
<script>
// import './Cover.scss'
import { mapState } from 'vuex';
import { getLoginInfo, performNativeLogin } from '@eastmoney/mku';
import { setAuthCookies, removeAuthCookies } from '@/libs/auth-cookie';
import {
    CHANGE_QUESTIONNAIRE_CODE,
    CHANGE_HAS_SHOW_COVER_PAGE,
    CHANGE_SECACCOUNT
} from '@/libs/constant';
import browser from '@/libs/browser';
import { setPageFullTopMode } from '@/libs/native';
import { FullTopMode, CoverFlag } from '@/libs/enum';
import LoginForm from './components/LoginForm';

export default {
    name: 'cover-page',
    components: {
        LoginForm
    },
    computed: {
        ...mapState(['coverConfig', 'needLogin', 'isRequestLoading']),
        titleList() {
            if (this.coverConfig && this.coverConfig.title) {
                const list = this.coverConfig.title.split('|');
                return list;
            }
            return [];
        },
        headerBgImage() {
            return {
                'background-image': `url(${this.coverConfig.coverPicUrl || ''})`,
                'background-repeat': 'repeat',
                'background-size': '100%'
            };
        },
        contents() {
            if (
                this.coverConfig &&
                this.coverConfig.content &&
                this.coverConfig.content.includes('\n')
            ) {
                return this.coverConfig.content.split('\n');
            }
            return [this.coverConfig.content];
        }
    },
    data() {
        return {
            isShowLogin: false
        };
    },
    methods: {
        async initQuestionnaire() {
            if (browser.isApp()) {
                // fix:清空ct,ut，解决客户端未登录也能正常答题问题
                removeAuthCookies();
            }
            const { code, secaccount } = this.$route.query;
            if (code) {
                this.$store.commit(CHANGE_QUESTIONNAIRE_CODE, code);
                this.$store.commit(CHANGE_SECACCOUNT, secaccount || undefined);
                await this.$store.dispatch('getQuestionConfig', code);
                this.$trackLaunch(this.$store.state.questionnaireCode);
            } else {
                this.$toast('当前页面地址不存在问卷代码');
            }
        },
        toHome() {
            this.$store.commit(CHANGE_HAS_SHOW_COVER_PAGE, true);
            const { code } = this.$route.query;
            this.$router.replace({
                name: 'home',
                params: { code }
            });
        },
        hanldeStartA() {
            // 不需要登录
            if (!this.needLogin) {
                this.$store.commit(CHANGE_HAS_SHOW_COVER_PAGE, true);
                this.toHome();
                return;
            }
            // 需要登录
            if (browser.isApp()) {
                this.handleAppLogin();
            } else {
                this.isShowLogin = true;
                this.$refs.loginform.show();
            }
        },
        handleAppLogin() {
            getLoginInfo(
                res => {
                    const { ct, ut } = res.data;
                    setAuthCookies({ ct, ut });
                    this.toHome();
                },
                () => {
                    performNativeLogin(
                        res => {
                            const { ct, ut } = res.data;
                            setAuthCookies({ ct, ut });
                            this.toHome();
                        },
                        () => {
                            console.log('登录失败');
                        }
                    );
                }
            );
        },
        async handleLoginSuccess() {
            const { code } = this.$route.query;
            if (code) {
                this.toHome();
            } else {
                this.$toast('当前页面地址不存在问卷代码');
            }
        }
    },
    async mounted() {
        try {
            await this.initQuestionnaire();
        } catch (error) {
            console.warn('initQuestionnaire failed:', error);
        }
        if (this.coverConfig.coverFlag === CoverFlag.yes) {
            setPageFullTopMode(FullTopMode.transparent);
        }
    }
};
</script>
<style lang="scss" scoped>
@import './Cover.scss';
</style>
